var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('div',{staticClass:"btn-tooltip-wrap"},[_c('div',{attrs:{"id":"ic3_thread"}}),_c('div',{staticClass:"tooltip-content"},[_vm._v(_vm._s(_vm.$t('HEADER.CHAT_BOT')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }